<template>
    <div id="app">
        <v-app>

            <vue-extend-layouts v-if="$auth.ready()" path="resources/views/layouts" />

            <v-container v-if="!$auth.ready()" fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-progress-linear indeterminate></v-progress-linear>
                    </v-flex>
                </v-layout>
            </v-container>
            
        </v-app>
    </div>
</template>

<script>
    import VueExtendLayouts from 'vue-extend-layout'
    import { Component, Vue } from 'vue-property-decorator'

    @Component({
        components: {
            VueExtendLayouts
        }
    })
    export default class App extends Vue {}

</script>

<style scoped>
body {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
